import React, { Fragment } from 'react';
import Chip from '@material-ui/core/Chip';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MoneyOffIcon from '@material-ui/icons/MoneyOff';
import { formatNumber } from '../../Utils/Money';

const ChipShowRetentionToInvoice = ({ retention }) => {
    return (
        <Fragment>
            <Chip
                variant="outlined"
                size="small"
                icon={<MoneyOffIcon style={{color: '#ff0e0e'}}/>}
                label={formatNumber(retention?.importe)}
                style={{margin: '0em 0.25em', color: '#ff0e0e'}}
            />
        </Fragment>
    )
}

export default ChipShowRetentionToInvoice